import { Analytics } from 'analytics';
import { analyticsPlugin } from './event-collector';
import { Api, fetchData } from './api';
import { AppConfig, config } from './AppConfig';
import { createApp, Env } from 'InternalLibrary';
import { datadogLogs } from '@datadog/browser-logs';
import i18n from 'i18next';

import './datadog/init';
import { spacesSanitizer } from './utils/sanitizers';

export const analyticsInstance = Analytics({
  app: 'registration.vivus.es',
  plugins: [
    ...(process.env.REACT_APP_EVENT_COLLECTOR_ENABLED === 'true' &&
    !(window as any).Cypress
      ? [
          analyticsPlugin({
            url: process.env.REACT_APP_ANALYTICS_API as string,
            app: {
              applicationType: 'new',
              env: process.env.REACT_APP_ENV as Env,
              type: 'web',
              version: '1.0.0',
            },
            dequeueInterval: 1000,
            onFetchError: (err) => {
              datadogLogs.logger.error(
                `Analytics event failed to fetch: ${JSON.stringify(
                  err,
                  null,
                  2,
                )}`,
              );
            },
          }),
        ]
      : []),
  ],
});

export const App = createApp<Api, AppConfig>({
  fetch: fetchData,
  analyticsInstance,
  config,
  translateError: (app, error) =>
    i18n.t(`notification:${error}`, {
      phone: config.phoneNumber,
      'phone-no-spaces': spacesSanitizer(config.phoneNumber),
    }),
  colaUrl: process.env.REACT_APP_COLA_URL || '',
});
